import { render } from "./Noticia.vue?vue&type=template&id=7e39190d"
import script from "./Noticia.vue?vue&type=script&lang=js"
export * from "./Noticia.vue?vue&type=script&lang=js"
script.render = render

export default script